import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUp, Github, Twitter, Linkedin, Youtube } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = {
    product: {
      title: '产品',
      links: [
        { name: '功能特性', href: '#features' },
        { name: '应用场景', href: '#use-cases' },
        { name: '定价方案', href: '#pricing' },
        { name: '更新日志', href: '#changelog' },
      ],
    },
    company: {
      title: '公司',
      links: [
        { name: '关于我们', href: '#about' },
        { name: '团队介绍', href: '#team' },
        { name: '新闻动态', href: '#news' },
        { name: '招聘信息', href: '#careers' },
      ],
    },
    support: {
      title: '支持',
      links: [
        { name: '帮助中心', href: '#help' },
        { name: '用户指南', href: '#guide' },
        { name: 'API 文档', href: '#api' },
        { name: '联系客服', href: '#contact' },
      ],
    },
    legal: {
      title: '法律',
      links: [
        { name: '隐私政策', href: '#privacy' },
        { name: '服务条款', href: '#terms' },
        { name: 'Cookie 政策', href: '#cookies' },
        { name: '版权声明', href: '#copyright' },
      ],
    },
  };

  const socialLinks = [
    { icon: Github, href: '#', label: 'GitHub' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Youtube, href: '#', label: 'YouTube' },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="brand-logo">
                <img src="/images/logo.svg" alt="电牙logo" className="logo-img" style={{ height: 40 }} />
              </div>
              <p className="brand-description">
                智能整理，释放创造力。让每一个想法都能转化为现实。
              </p>
            </div>

            <div className="footer-links">
              {Object.entries(footerLinks).map(([key, section]) => (
                <div key={key} className="link-group">
                  <h4 className="link-title">{section.title}</h4>
                  <ul className="link-list">
                    {section.links.map((link, index) => (
                      <li key={index}>
                        <a href={link.href} className="link-item">
                          {link.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-social">
              <span className="social-title">关注我们</span>
              <div className="social-links">
                {socialLinks.map((social, index) => {
                  const IconComponent = social.icon;
                  return (
                    <motion.a
                      key={index}
                      href={social.href}
                      className="social-link"
                      aria-label={social.label}
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                    >
                      <IconComponent size={20} />
                    </motion.a>
                  );
                })}
              </div>
            </div>

            <div className="footer-copyright">
              <p>&copy; 2025 改变世界（深圳）人工智能科技有限公司 版权所有.</p>
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备2025411323号</a>
            </div>
          </div>
        </div>

        <motion.button
          className="back-to-top"
          onClick={scrollToTop}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <ArrowUp size={20} />
        </motion.button>
      </div>
    </footer>
  );
};

export default Footer; 